import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { CtwrItemService, CtwrComponentService } from '../../../ctwr.service';

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.scss']
})
export class ItemsComponent extends DataGridTemplate implements OnInit {
  private readonly itemTitle = 'Item Description';
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly itemService: CtwrItemService,
    private readonly componentService: CtwrComponentService
  ) {
    super();
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.editForm = this.formBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
      ComponentIds: []
    })

    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };

    this.formDialog.initilize(this.itemTitle, this.editForm, this.formDialogTabs);
    this.componentService.read();
  }

  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next(this.editDataItem);
    this.editForm.get('Name').enable();
  }

  read(opts: any): Promise<any> {
    return opts.force ?
      this.itemService.read('') :
      Promise.resolve(this.itemService.value);
  }

  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.itemService.read(`/${dataItem.Id}`)
      .then(x => {
        this.formDialog.next(x);
      })
    this.editForm.get('Name').disable();
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    const _path: string = isNew ? '' : (`/${dataItem.Id}`);
    return this.itemService.save(dataItem, isNew, _path, false)
  }

  delete(dataItem: any): Promise<any> {
    return this.itemService.remove(`/${dataItem.Id}`, false)
  }

  columns: any[] = [
    {
      field: 'Name',
      title: this.itemTitle,
    },
    {
      field: 'ItemNames',
      title: 'Item Names',
    }
  ]

  formControls = [
    {
      type: 'text',
      title: this.itemTitle,
      name: 'Name',
      placeholder: 'Enter an Item Description',
      stretch: true,
      invalidText: 'Input must be between 1 and 65 characters.'
    },
    {
      type: "multiselect",
      title: "Item Names",
      name: "ComponentIds",
      textField: "Name",
      valueField: "Id",
      service: this.componentService,
      stretch: true
    },
  ]

  formDialogTabs = [
    {
      title: "Item Descriptions",
      selected: true,
      formControls: this.formControls
    },
  ]
}
